const TrialBadge = () => {
  const TRIAL_DAYS = 7;

  const createdAt = localStorage.getItem("createdAt");

  // Safety check
  if (!createdAt) return null;

  const createdDate = new Date(createdAt);
  const today = new Date();

  createdDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - createdDate.getTime();
  const daysPassed = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  const remainingDays = Math.max(TRIAL_DAYS - daysPassed, 0);
  let style;
  if (remainingDays <= 0) return null;
  if (remainingDays > 3) {
    style = {
      container:
        "px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 border border-yellow-300 bg-yellow-100 text-yellow-700",
      icon: "⚠️",
      message: `Trial ending soon — ${remainingDays} days remaining`,
    };
  } else if (remainingDays > 0) {
    style = {
      container:
        "px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 border border-red-300 bg-red-100 text-red-700",
      icon: "⛔",
      message: `Trial almost over — ${remainingDays} day${remainingDays > 1 ? "s" : ""} remaining`,
    };
  } else {
    style = {
      container:
        "px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 border border-red-300 bg-red-200 text-red-700",
      icon: "❌",
      message: "Trial expired — please upgrade",
    };
  }

  return (
    <div className={`${style.container}`}>
      <span className="text-lg">{style.icon}</span>
      <span className="font-medium">{style.message}</span>
    </div>
  );
};

export default TrialBadge;
